import React from 'react';
import {SubMenuProps} from './SubMenu';
import {Quality} from '../../../ui-components/Iconpack';
import {QualitySubMenuItems} from '../../../components/quality-submenu/QualitySubmenuList';
import {toast} from 'react-toastify';

export const QualitySubMenu: React.FC<SubMenuProps> = (props) => {
    const handleQualityChange = (quality: string, qualityTitle: string) => {
        props.trackEvent('QualityChangeClicked', {quality: quality});
        props.updateTransformationObject({
            ...props.transformationObject,
            quality,
        });
        toast.success(`Image quality changed to ${qualityTitle}`);
    };
    return (
        <>
            <div className='flex items-center'>
                <div className='block cursor-pointer items-center justify-center rounded-[6px] border-[2px] border-[#4E5BA6] bg-[#717BBC] p-[12px] md:mx-[16px] md:hidden'>
                    <Quality color='#FFFFFF' />
                </div>
                <div className='flex flex-col pl-[6px] text-[14px] font-[700] text-[#FFFFFF] md:pl-0'>
                    <span>IMAGE QUALITY</span>
                </div>
            </div>
            <span className='flex flex-col gap-5 pt-6 text-[12px] font-[700] text-[#FFFFFF] md:pt-5'>
                Set image quality
            </span>
            <div className='mt-[18px]'>
                <ul className='flex flex-col justify-center gap-4 pt-4'>
                    {QualitySubMenuItems.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={'cursor-pointer'}
                                onClick={() => handleQualityChange(item.value, item.title)}>
                                <li
                                    key={item.title}
                                    className={`flex items-center justify-between rounded-[6px] border 
                                    border-[#3E4784] bg-[#293056] py-[13px] pl-[10px] pr-[16px] 
                                    ${props.transformationObject.quality === item.value ? 'bg-[#717BBC]' : ''}`}>
                                    <div className={'flex justify-between gap-2'}>
                                        <input
                                            type='radio'
                                            className='h-4 w-4'
                                            checked={props.transformationObject.quality === item.value}
                                        />
                                        <span className={`text-[12px] font-[700] text-[#FFFFFF]`}>{item.title}</span>
                                    </div>
                                    <span className={`text-[12px] font-[700] text-[#FFFFFF]`}>
                                        {item.displayPercent}
                                    </span>
                                </li>
                            </div>
                        );
                    })}
                </ul>
            </div>
        </>
    );
};
